export const MEETING_AGENT_SOURCE = {
    gCalendar: "G-calendar",
} as const;

export type MeetingAgentSource = (typeof MEETING_AGENT_SOURCE)[keyof typeof MEETING_AGENT_SOURCE];
